import { render, staticRenderFns } from "./PaymentSettingsYezzaPayMigrateBanner.vue?vue&type=template&id=75f4dd40&scoped=true&lang=pug&"
import script from "./PaymentSettingsYezzaPayMigrateBanner.vue?vue&type=script&lang=js&"
export * from "./PaymentSettingsYezzaPayMigrateBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f4dd40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCol,VRow})
